import { Order } from '../store/order/api/interface';

const toArray = <T>(value: T[] | null | undefined): T[] =>
  Array.isArray(value) ? value : [];

/** Normalize Sequelize / Feathers order payload keys for the admin UI */
export const normalizeOrderRecord = (order: any): Order => {
  if (!order) {
    return order;
  }

  const plain =
    typeof order.get === 'function'
      ? order.get({ plain: true })
      : typeof order.toJSON === 'function'
        ? order.toJSON()
        : order;

  return {
    ...plain,
    order_items: toArray(
      plain.order_items ?? plain.order_item ?? plain.orderItems
    ),
    order_bundle_items: toArray(
      plain.order_bundle_items ??
        plain.order_bundle_item ??
        plain.orderBundleItems
    ),
  };
};
